import type { IconData } from '@stacksjs/iconify-core'

export const chatTwoBubblesOval: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path stroke-linecap=\"round\" d=\"M42.6 19C40.747 9.871 32.676 3 23 3C11.954 3 3 11.954 3 23c0 3.796 1.058 7.345 2.894 10.369c-.891 2.137-1.798 4.663-2.378 6.985c-.325 1.303.818 2.401 2.112 2.042c2.243-.623 4.711-1.53 6.838-2.392A19.9 19.9 0 0 0 19 42.6\"/><path d=\"M21 33c0-6.627 5.373-12 12-12s12 5.373 12 12c0 2.303-.648 4.454-1.773 6.28c.431.912.86 1.961 1.2 3.086c.387 1.286-.765 2.391-2.041 1.974a29 29 0 0 1-2.994-1.182A11.94 11.94 0 0 1 33 45c-6.627 0-12-5.373-12-12Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default chatTwoBubblesOval
